import amplitude from 'amplitude-js';
import { devicePlateForm, deviceOS } from 'utils/device-util';
import { distributorNameEn } from 'config';

class amplitudeService {
  track = (name, properties = {}, callback) => {
    properties['custom_platform'] = devicePlateForm();
    properties['deviceOS'] = deviceOS();
    properties['distributor'] = distributorNameEn();

    amplitude.getInstance().logEvent(name, properties, callback);
  };
}

export default new amplitudeService();
